import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Application } from '../../appBuilder/appDetails/types';

interface AppAnalytics {
  appDetail: Application;
  analyticsLogs: any[];
}

const initialState: AppAnalytics = {
  appDetail: {
    appId: '',
    name: '',
    appImageExists: false,
    httpProvider: [],
  },
  analyticsLogs: [],
};

const appAnalyticsSlice = createSlice({
  name: 'appAnalytics',
  initialState,
  reducers: {
    updateAppAnaytics(state, action: PayloadAction<Partial<AppAnalytics>>) {
      Object.assign(state, action.payload);
    },
    resetAppAnalytics() {
      return { ...initialState };
    },
  },
});

export const { updateAppAnaytics, resetAppAnalytics } = appAnalyticsSlice.actions;

export default appAnalyticsSlice.reducer;
